/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Print_Admin_Status_FailedInputs */

const vi_print_admin_status_failed = /** @type {(inputs: Print_Admin_Status_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In lỗi`)
};

/**

* @param {Print_Admin_Status_FailedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const print_admin_status_failed = /** @type {((inputs?: Print_Admin_Status_FailedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Print_Admin_Status_FailedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_print_admin_status_failed(inputs)
});